import DialogComponent from "components/Dialog";

export default class CabinetDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            workDays: [1, 2, 3, 4, 0],
            diffSheet: false,
        };

        this.state = {
            ...this.state,
            name: "",
            id: null,
            domainId: null
        };
    }

    title = "schedule.addCabinet";

    show(info, hidCb) {
        const { create, name, id, domainId } = info;
        this.dialogTitle = create ? "schedule.addCabinet" : "schedule.editCabinet";
        this.setState({ name, id, domainId });

        this.hidCb = hidCb;
        super.show();
    }

    async save() {
        const { id, name, domainId } = this.state;
        this._helper.showLoading();

        const info = {
            title: name,
            domainId,
            status: "ACTIVE"
        };

        let resp = null;
        if (id)
            resp = await this._request.cabinets.update(id, info);
        else
            resp = await this._request.cabinets.add(info);

        this._helper.hideLoading();

        if (resp?.data) {
            this.hide();

            if (this.hidCb?.apply)
                this.hidCb();
        }
    }

    renderContent() {
        const { name } = this.state;

        return (
            <div className="workHoursDialog content flex col gap16 pos rel">
                {this.insertInput({
                    ref: el => this.nameInput = el,
                    value: name,
                    placeHolder: "schedule.nameCabinet",
                    onChange: this.changeState.bind(this, "name")
                })}
            </div>
        );
    }
}
